<nav class="navbar navbar-dark bg-dark">
  <div class="wrapper">
    <a class="logo" href="/">
      <img src="assets/logo_white.png" style="height: 20px" />
    </a>

    <div class="title">
      <man-pool-breadcrumb></man-pool-breadcrumb>
    </div>

    <div class="menu">
      <man-user-menu
        *ngIf="currentUser$ | async as currentUser"
        [user]="currentUser"
        (logout)="onLogout()"
      ></man-user-menu>
    </div>
  </div>
</nav>
